import apiClient from './api';

/**
 * Servicio para gestionar el progreso de usuarios en exámenes (tabla intermedia usuario_examen)
 */
export const usuarioExamenService = {
  /**
   * Obtener todos los registros de usuario-examen
   */
  getAllUsuarioExamenes: async () => {
    const response = await apiClient.get('/usuario-examen');
    return response.data;
  },

  /**
   * Asignar un examen a un usuario (estado: NO_INICIADO)
   */
  asignarExamen: async (usuarioId, examenId) => {
    const response = await apiClient.post('/usuario-examen/asignar', {
      usuarioId,
      examenId
    });
    return response.data;
  },

  /**
   * Iniciar un examen (estado: NO_INICIADO -> EN_PROGRESO)
   */
  iniciarExamen: async (usuarioId, examenId) => {
    const response = await apiClient.post('/usuario-examen/iniciar', {
      usuarioId,
      examenId
    });
    return response.data;
  },

  /**
   * Actualizar progreso del examen
   */
  actualizarProgreso: async (usuarioId, examenId, porcentajeCompletado, tiempoRestanteSegundos = null) => {
    const response = await apiClient.put('/usuario-examen/progreso', {
      usuarioId,
      examenId,
      porcentajeCompletado,
      tiempoRestanteSegundos
    });
    return response.data;
  },

  /**
   * Finalizar examen con puntaje (estado: EN_PROGRESO -> FINALIZADO)
   */
  finalizarExamen: async (usuarioId, examenId, puntajeObtenido, puntajeMaximo, observaciones = null) => {
    const response = await apiClient.post('/usuario-examen/finalizar', {
      usuarioId,
      examenId,
      puntajeObtenido,
      puntajeMaximo,
      observaciones
    });
    return response.data;
  },

  /**
   * Marcar examen como abandonado
   */
  abandonarExamen: async (usuarioId, examenId) => {
    const response = await apiClient.post('/usuario-examen/abandonar', {
      usuarioId,
      examenId
    });
    return response.data;
  },

  /**
   * Marcar examen como tiempo agotado
   */
  tiempoAgotado: async (usuarioId, examenId) => {
    const response = await apiClient.post('/usuario-examen/tiempo-agotado', {
      usuarioId,
      examenId
    });
    return response.data;
  },

  /**
   * Obtener progreso específico de un usuario en un examen
   */
  obtenerProgreso: async (usuarioId, examenId) => {
    const response = await apiClient.get(`/usuario-examen/progreso/${usuarioId}/${examenId}`);
    return response.data;
  },

  /**
   * Obtener todos los exámenes de un usuario
   */
  obtenerExamenesUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/usuario-examen/usuario/${usuarioId}`);
    return response.data;
  },

  /**
   * Obtener todos los usuarios de un examen
   */
  obtenerUsuariosExamen: async (examenId) => {
    const response = await apiClient.get(`/usuario-examen/examen/${examenId}`);
    return response.data;
  },

  /**
   * Obtener exámenes en progreso de un usuario
   */
  obtenerExamenesEnProgreso: async (usuarioId) => {
    const response = await apiClient.get(`/usuario-examen/en-progreso/${usuarioId}`);
    return response.data;
  }
};

export default usuarioExamenService;
